import { render } from "./ArtworkView.vue?vue&type=template&id=dbb10ed4&scoped=true&ts=true"
import script from "./ArtworkView.vue?vue&type=script&lang=ts"
export * from "./ArtworkView.vue?vue&type=script&lang=ts"

import "./ArtworkView.vue?vue&type=style&index=0&id=dbb10ed4&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dbb10ed4"]])

export default __exports__